var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-base',{attrs:{"show-close":""},on:{"close":_vm.close}},[_c('img',{staticClass:"mod-map",attrs:{"src":require('../../../assets/dialog/dialog-share-map.jpg'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }